'use client';

import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import UploadResume from '@/components/resume/resume-upload/UploadResume';
import UploadInfo from './UploadInfo';
import { HOME_PAGE_RESUME_EVALUATION_ID } from '@/constants/component-id';

const EVALUATION_STEPS = ['上传简历', '填写目标岗位', '开始分析'];

const ResumeEvaluation = () => {
  const [resumeFile, setResumeFile] = React.useState<File | null>(null);
  const [evaluationStep, setEvaluationStep] = React.useState(0);

  return (
    <div
      id={HOME_PAGE_RESUME_EVALUATION_ID}
      className="px-5 my-10 tablet:my-25 tablet:px-22.5"
      data-ele-id="content"
      data-ele-group="3rd_screen_简历诊断"
      data-observer-id="3rd_screen_简历诊断"
    >
      <div className="tablet:max-w-[1200px] tablet:mx-auto">
        <p className="text-3xl font-semibold text-center mb-10 tablet:text-4.5xl">
          只需3步，让你的简历被HR一眼相中
        </p>
        <p className="text-center text-lg tablet:text-xl">
          谈职调研发现：超 60% 的简历存在结构性问题，80%
          缺乏清晰表达与岗位匹配度
        </p>
        <p className="text-center mb-10 text-lg tablet:text-xl">
          一键诊断简历问题，向理想 offer 更进一步！
        </p>
        <Stepper activeStep={evaluationStep}>
          {EVALUATION_STEPS.map((label, index) => (
            <Step key={label + index} disabled={false} className="!text-white">
              <StepLabel
                StepIconProps={{
                  className:
                    '!text-4xl !text-white border rounded-full border-slate-300 [&.Mui-active]:!text-web-blue-500 [&.Mui-completed]:!text-web-blue-500 [&.Mui-active]:border-blue-400 [&.Mui-active_.MuiStepIcon-text]:!fill-white [&_.MuiStepIcon-text]:!fill-black/80 tablet:!text-5.75xl',
                }}
                componentsProps={{
                  label: {
                    className:
                      '!text-primary !text-lg !font-normal tablet:!text-xl',
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div className="mt-10 rounded-lg bg-web-blue-100 tablet:py-12">
          {evaluationStep === 0 ? (
            <UploadResume
              setResumeFile={setResumeFile}
              dataEleGroup="3rd_screen_简历诊断"
              setEvaluationStep={setEvaluationStep}
            />
          ) : (
            <UploadInfo
              resumeFile={resumeFile}
              dataEleGroup="3rd_screen_简历诊断"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumeEvaluation;
